import loadable from '@loadable/component';
import LoadingComponent from 'components/Loaders/LoadingComponent';

const ParcelInvoicesXMLLoadable = loadable(
  () => import(/* webpackChunkName: 'admin-parcel-invoices-xml' */ './ParcelInvoicesXML'),
  {
    fallback: <LoadingComponent />,
  }
);

const ParcelInvoicesXML = (prop: any) => <ParcelInvoicesXMLLoadable {...prop} />;

export default ParcelInvoicesXML;
